import React, { Component, useEffect, useState } from "react";
import Form from "../../../comman/form";
import http from "../../../services/HttpService";
import config from "../../../config.json";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Joi from "joi-browser";
import Swal from "sweetalert2";
import AddSubcontractor from "../AddSubcontractor";
import { useDispatch, useSelector } from "react-redux";
import { getPartnerListByType, getSubcontractorPartners, loadPartnerListByType, loadSubcontractorPartners } from "../../../app/store/partner";
import { getApplicationData } from "../../../app/store/application";
import { getCandidateUpatedStatus, updateNewCandidate } from "../../../app/store/candidate";
import { addNewRates, getRateUpdatedStatus, ratesReceived, updateRate } from "../../../app/store/rates";
import { getAlert } from "../../../services/appAlerts";
import { loadSubcontractors } from "../../../app/store/subcontractor";
import { getDataTypeApplicationReports, loadDataTypeApplicationReports } from "../../../app/store/reports";
import { getCurrentUser } from "../../../app/store/auth";

const Subcontractor = (props) => {

  const { candidateObj, actType, handleNextTab, updateSelectedObject, rateHistory } = props;

  const [subcontractors, setSubcontractors] = useState([]);
  const [selectedSubcontractorId, setSelectedSubcontractorId] = useState(0);
  const [subcontractorRate, setSubcontractorRate] = useState(0);
  const [subcontractorLessFee, setSubcontractorLessFee] = useState(0);
  const [subcontractorFinalRate, setSubcontractorFinalRate] = useState(0);
  const [partnerType, setPartnerType] = useState("Sub-Contractors");
  const [aworkfinityApp, setAworkfinityApp] = useState(null);
  const [showHideSub, setShowHideSub] = useState(false);
  const [showDetailSub, setShowDetailSub] = useState(false);
  const [allReportData, setAllReportData] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [selectedJsonData, setSelectedJsonData] = useState("");
  const [partnerListByType, setPartnerListByType] = useState([]);
  const [compName, setCompName] = useState("");
  const [btnUnable, setBtnUnable] = useState(false);

  const subcontractorPartnersSelector = useSelector(getSubcontractorPartners);
  const rateUpdatedStatusSelector = useSelector(getRateUpdatedStatus)
  const partnerListByTypeSelector = useSelector(getPartnerListByType);
  const dataTypeApplicationReportsSelector = useSelector(getDataTypeApplicationReports);

  const candidateUpatedStatusSelector = useSelector(getCandidateUpatedStatus)

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    dispatch(loadSubcontractorPartners(partnerType))
    //dispatch(loadPartnerListByType(partnerType));
  }, []);

  useEffect(() => {
    if (subcontractorPartnersSelector.length > 0) {
      setSubcontractors(subcontractorPartnersSelector);
      dispatch(loadDataTypeApplicationReports());
    }
  }, [subcontractorPartnersSelector]);

  useEffect(() => {
    setPartnerListByType(partnerListByTypeSelector);
  }, [partnerListByTypeSelector]);

  useEffect(() => {
    if (dataTypeApplicationReportsSelector.length > 0) {
      const rptDt = dataTypeApplicationReportsSelector;
      setAllReportData(rptDt);
    }
  }, [dataTypeApplicationReportsSelector]);

  useEffect(() => {
    if (!candidateObj)
      setSelectedSubcontractorId(0);

    if (candidateObj?.subcontractor)
      setSelectedSubcontractorId(candidateObj.validId);

    const data = { ...rateHistory[rateHistory.length - 1] };
    if (data["subcontractorRate"]) {
      setSubcontractorFinalRate(data["subcontractorRate"])
      setSubcontractorLessFee(data["subcontractorTechFee"] || 0)
      setSubcontractorRate(parseFloat(data["subcontractorRate"]) + parseFloat(data["subcontractorTechFee"] || 0))
    } else if (actType === "edit") {
      setSubcontractorFinalRate("")
      setSubcontractorLessFee("")
      setSubcontractorRate("")
    }

    if (candidateObj?.performerData) {
      const obj = getApplicationData(candidateObj.performerData);
      if (obj?.aWorkfinityApp)
        setAworkfinityApp(obj.aWorkfinityApp);
    }
    setBtnUnable(false)

  }, [candidateObj, rateHistory]);

  useEffect(() => {
    if (allReportData.length > 0) {
      let rptData = [];
      rptData = allReportData.filter((x) => x.name === "SubcontractorEnrollmentForm");
      setReportData(rptData);
    }

  }, [allReportData])

  const handleSubmit = (btnType) => {
    const NewAWorkfinityApp = { ...aworkfinityApp };
    const appName = Object.keys(NewAWorkfinityApp)[1];
    const aWorkfinityAppEntity = NewAWorkfinityApp[appName];
    if (selectedSubcontractorId > 0) {
      const subs = subcontractors.filter(x => x.fuid === parseInt(selectedSubcontractorId));
      if (subs.length > 0) {
        const subDetails = JSON.parse(subs[0].createdBy);
        const appEntity = subDetails[appName];
        aWorkfinityAppEntity["subcontractorenrollmentform"] = appEntity["subcontractorenrollmentform"];
        NewAWorkfinityApp[appName] = aWorkfinityAppEntity;
        setBtnUnable(true)
        const formData = new FormData();
        formData.append("appEntity", JSON.stringify(NewAWorkfinityApp));
        formData.append("subcontractor", selectedSubcontractorId);
        formData.append("recruiter", "");
        formData.append("perfId", candidateObj.performerid);
        dispatch(updateNewCandidate(formData));
        // if (actType === "edit") {
        //   updateSelectedObject(candidateObj.performerid, aworkfinityApp);
        // } else {
        //   updateSelectedObject(candidateObj.performerid);
        // }
        //handleSaveRates();

        // if (actType === "edit"){
        //   getAlert("", "Updated Successfully", "success");
        // }
        // else{
        //   getAlert("", "Saved Successfully", "success");
        // }
        //updateSelectedObject(candidateObj.performerid);
        //dispatch(ratesReceived([]));
        //handleNextTab(btnType);
        setCompName("subcontractor")
      }
    }

  };


  const handleUpdaterates = () => {
    const data = { ...rateHistory[rateHistory.length - 1] };
    const rateObj = {
      performerId: candidateObj.performerid,
      id: data.id,
      addedBy: currentUser.id,
      notes: data["notes"],
      subcontractorRate: subcontractorFinalRate || 0,
      SubcontractorTechFee: subcontractorLessFee || 0,
      CandidateTechFee: data["candidateTechFee"] || 0,
      RecruiterTechFee: data["recruiterTechFee"] || 0,
      AgencyTechFee: data["agencyTechFee"] || 0,
      recruiterRate: data["recruiterRate"] || 0,
      candidateRate: data["candidateRate"] || 0,
      agencyRate: data["agencyRate"] || 0,
      candidateEffectiveDate: data["candidateEffectiveDate"] || new Date().toISOString(),
      agencyEffectiveDate: data["agencyEffectiveDate"] || new Date().toISOString(),
      subcontractorEffectiveDate: data["subcontractorEffectiveDate"] || new Date().toISOString(),
      recruiterEffectiveDate: data["recruiterEffectiveDate"] || new Date().toISOString(),
    };
    dispatch(addNewRates(rateObj))
  }

  useEffect(() => {
    if (candidateUpatedStatusSelector && compName === "subcontractor") {
      setCompName("");
      if (actType === "edit") {
        getAlert("", "Updated Successfully", "success");
        handleUpdaterates()
      }
      else {
        getAlert("", "Saved Successfully", "success");
      }

      updateSelectedObject(candidateObj.performerid, aworkfinityApp);
      handleSaveRates();
      //handleNextTab(btnType);
    }
  }, [candidateUpatedStatusSelector])

  const getAttributeValue = (d, t, att) => {
    if (d?.appData && d.appData === "") return "";
    const itemValues = JSON.parse(d.appData);
    const appShortName = Object.keys(itemValues)[1];
    const items = itemValues[appShortName][t.name.toLowerCase()];
    return items && items["@" + att];
  };

  const getAttribute = (t) => {
    if (t?.data && t?.data !== "") {
      const items = JSON.parse(t.data);
      return items;
    }
    return [];
  };

  const handleAddEditSubcontractor = (data) => {
    if (data === "exit") {
      setShowHideSub(!showHideSub)
      dispatch(loadSubcontractorPartners(partnerType))
      //dispatch(loadPartnerListByType(partnerType))
    }
  }

  const handleSaveRates = () => {
    const frmData = new FormData();
    frmData.append("id", candidateObj.performerid);
    frmData.append("type", "subcontractor");
    frmData.append("subRate", subcontractorFinalRate || 0);
    frmData.append("subTechFee", subcontractorLessFee || 0);
    dispatch(updateRate(frmData));
  };

  useEffect(() => {
    const rate = parseFloat(subcontractorRate) || 0;
    const lessFee = parseFloat(subcontractorLessFee) || 0;

    const finalRate = rate - lessFee;
    setSubcontractorFinalRate(isNaN(finalRate) ? 0 : finalRate);
  }, [subcontractorRate, subcontractorLessFee]);

  const ChangeRatePerHour = (rateVal) => {
    const rate = parseFloat(rateVal) || 0;
    setSubcontractorRate(rate);
  };

  const ChangeLessTechFee = (rateVal) => {
    const fee = parseFloat(rateVal) || 0;
    if (fee <= subcontractorRate || isNaN(fee)) {
      setSubcontractorLessFee(fee);
    }
  };

  const handleSubShow = () => {
    setShowHideSub(!showHideSub)
    setShowDetailSub(false)
  }

  const handleSubDetails = () => {
    setShowHideSub(false)
    setShowDetailSub(!showDetailSub)
    const id = selectedSubcontractorId
    let jsonData = "";
    const partner = partnerListByType.filter((x) => x.fuid === parseInt(id));
    if (partner.length > 0) {
      jsonData = partner[0].contact1?.performerData
    }
    setSelectedJsonData(jsonData);
  }

  const handleChangeSubcontractor = ({ currentTarget: input }) => {
    const id = input.value;
    setSelectedSubcontractorId(parseInt(id));
    dispatch(loadPartnerListByType(partnerType, id));
    setShowHideSub(false);
    setShowDetailSub(false);
  }

  const btnDisabled = selectedSubcontractorId > 0 && subcontractorRate > 0;

  return (
    <div className="col-md-12">
      <div className="row">
        <button
          className="btn btn-sm btn-outline-default ml-3 mb-2"
          onClick={() => handleSubShow()}
        >
          Add New Subcontractor
        </button>
        {selectedSubcontractorId ?
          <button
            className="btn btn-sm btn-outline-default ml-3 mb-2"
            onClick={() => handleSubDetails()}
          >
            View Subcontractor Details
          </button> : ""
        }
        {
          !showHideSub ?
            <>
              <div className="col-md-12 form-group">
                <p className="text-red">
                  <i className="fa fa-hand-o-right mr-2" aria-hidden="true"></i>
                  If existing subcontractor, Select subcontractor and enter the rate
                  to be paid
                </p>
              </div>
              <div className="col-md-3 form-group">
                <label htmlFor="subcontractor" className="form-control-label">
                  Select Subcontractor
                </label>
                <select
                  name="subcontractor"
                  id="subcontractor"
                  className="form-control"
                  onChange={handleChangeSubcontractor}
                  value={selectedSubcontractorId}
                >
                  <option value="">Select</option>
                  {subcontractors.map((item) => (
                    <option value={item.fuid}>{item.label}</option>
                  ))}
                </select>
              </div>

              <div className="col-md-3 form-group">
                <label htmlFor="subcontractor" className="form-control-label">
                  Rate/Hour-Paid to Subcontractor $
                </label>
                <input
                  className="form-control"
                  type="number"
                  name="rate"
                  id="rate"
                  value={subcontractorRate}
                  disabled={!selectedSubcontractorId}
                  onChange={({ currentTarget }) => ChangeRatePerHour(currentTarget.value)}
                />
              </div>

              <div className="col-md-3 form-group">
                <label htmlFor="SubcontractorTechFee" className="form-control-label">
                  Less Tech Fee $
                </label>
                <input
                  className="form-control"
                  type="number"
                  name="SubcontractorTechFee"
                  id="SubcontractorTechFee"
                  value={subcontractorLessFee}
                  disabled={!selectedSubcontractorId}
                  onChange={({ currentTarget }) => ChangeLessTechFee(currentTarget.value)}
                />
              </div>

              <div className="col-md-3 form-group">
                <label htmlFor="FinalValue" className="form-control-label">
                  Final Subcontractor Rate $
                </label>
                <input
                  className="form-control"
                  type="number"
                  name="FinalValue"
                  disabled
                  id="FinalValue"
                  value={subcontractorFinalRate}
                />
              </div>

              <div className="col-md-12 text-center form-group">
                <button
                  className="btn btn-sm btn-outline-default mb-2"
                  disabled={!btnDisabled || btnUnable}
                  onClick={() => handleSubmit("save")}
                >
                  <i className="fa fa-check" aria-hidden="true"></i> Save
                </button>
                {/* <br />
                <button
                  className="btn btn-sm btn-outline-default"
                  disabled={!btnDisabled}
                  onClick={() => handleSubmit("saveAndContinue")}
                >
                  <i className="fa fa-check" aria-hidden="true"></i> Save and Continue
                </button> */}
              </div>
              {
                showDetailSub &&
                <>

                  {selectedJsonData && reportData.map((t, key) => (
                    <table className="table border align-items-center table-flush">
                      <thead className="thead-light">
                        {getAttribute(t).length > 0 &&
                          getAttribute(t).map((m) => (
                            <tr>
                              <td style={{ width: "20%", backgroundColor: "#f6f6f6" }} className="p-2">{m.Label}</td>
                              <td className="p-2">
                                {getAttributeValue({ appData: selectedJsonData }, t, m.Name)}
                              </td>
                            </tr>
                          ))}
                      </thead>
                    </table>
                  ))}
                </>
              }
            </> :
            <div className="ml-3">
              <AddSubcontractor
                handleAddEditSubcontractor={handleAddEditSubcontractor}
                selectedTab="addEditSubcontractor"
              />
            </div>
        }
      </div>
    </div>
  );
}

export default Subcontractor;
